/**
 * Mamash PDP — interactivity
 *
 * Features:
 * - Image gallery: thumbnail navigation, prev/next, autoplay (4 s)
 * - Lightbox: open/close, prev/next, keyboard ESC/arrows
 * - Variant selector: updates hidden .product-variant-id input + price/compare-price display
 * - Quantity stepper: +/- buttons clamp to 1–99
 * - Sticky mobile CTA: slides up when #mamash-atc-row scrolls out of view (IntersectionObserver)
 * - GoKwik data-variantid sync on variant change
 */
(function () {
  'use strict';

  /* ─── Data injected by product-main.liquid ───────────────────────────── */
  var data = window.mamashProductData || { variants: [], galleryImages: [], currentVariantId: null };
  var variants = data.variants || [];
  var galleryImages = data.galleryImages || [];
  var currentIndex = 0;

  /* ─── Elements ──────────────────────────────────────────────────────── */
  var mainImg = document.getElementById('mamash-main-img');
  var thumbsContainer = document.getElementById('mamash-gallery-thumbs');
  var lightboxEl = document.getElementById('mamash-lightbox');
  var lightboxImg = document.getElementById('mamash-lightbox-img');
  var variantIdInput = document.querySelector('.product-variant-id');

  /* ══════════════════════════════════════════════════════════════════════
     GALLERY
  ══════════════════════════════════════════════════════════════════════ */
  function showImage(index) {
    if (galleryImages.length === 0) return;
    currentIndex = (index + galleryImages.length) % galleryImages.length;
    var imgData = galleryImages[currentIndex];
    if (mainImg) {
      mainImg.src = imgData.src;
      mainImg.alt = imgData.alt;
    }
    // Update thumb borders
    if (thumbsContainer) {
      thumbsContainer.querySelectorAll('.mamash-thumb').forEach(function (t, i) {
        if (i === currentIndex) {
          t.classList.add('border-primary');
          t.classList.remove('border-transparent');
        } else {
          t.classList.remove('border-primary');
          t.classList.add('border-transparent');
        }
      });
    }
  }

  // Thumbnails
  if (thumbsContainer) {
    thumbsContainer.querySelectorAll('.mamash-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showImage(parseInt(btn.dataset.index, 10));
      });
    });
  }

  // Prev / Next arrows
  var prevBtn = document.querySelector('.mamash-gallery-prev');
  var nextBtn = document.querySelector('.mamash-gallery-next');
  if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

  // Autoplay (4 s)
  var autoplayTimer = null;
  function startAutoplay() {
    if (galleryImages.length <= 1) return;
    autoplayTimer = setInterval(function () { showImage(currentIndex + 1); }, 4000);
  }
  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
  }
  var galleryMain = document.getElementById('mamash-gallery-main');
  if (galleryMain) {
    galleryMain.addEventListener('mouseenter', stopAutoplay);
    galleryMain.addEventListener('mouseleave', startAutoplay);
  }
  startAutoplay();

  // Swipe support on main image
  if (galleryMain && galleryImages.length > 1) {
    var touchStartX = 0;
    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        showImage(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  }

  /* ══════════════════════════════════════════════════════════════════════
     LIGHTBOX
  ══════════════════════════════════════════════════════════════════════ */
  function openLightbox(index) {
    if (!lightboxEl || !lightboxImg || galleryImages.length === 0) return;
    var i = (index + galleryImages.length) % galleryImages.length;
    lightboxImg.src = galleryImages[i].src;
    lightboxImg.alt = galleryImages[i].alt;
    lightboxEl.classList.remove('hidden');
    lightboxEl.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    currentIndex = i;
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.add('hidden');
    lightboxEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var openBtn = document.getElementById('mamash-lightbox-open');
  if (openBtn) openBtn.addEventListener('click', function () { openLightbox(currentIndex); });

  var closeBtn = document.getElementById('mamash-lightbox-close');
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

  var lbPrev = document.getElementById('mamash-lightbox-prev');
  var lbNext = document.getElementById('mamash-lightbox-next');
  if (lbPrev) lbPrev.addEventListener('click', function () { openLightbox(currentIndex - 1); });
  if (lbNext) lbNext.addEventListener('click', function () { openLightbox(currentIndex + 1); });

  if (lightboxEl) {
    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl) closeLightbox();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!lightboxEl || lightboxEl.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') openLightbox(currentIndex - 1);
    if (e.key === 'ArrowRight') openLightbox(currentIndex + 1);
  });

  /* ══════════════════════════════════════════════════════════════════════
     VARIANT SELECTOR
  ══════════════════════════════════════════════════════════════════════ */
  // Build selected options state from current variant
  var selectedOptions = [];
  var currentVariant = variants.find(function (v) { return v.id === data.currentVariantId; });
  if (currentVariant) {
    selectedOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3];
  }

  function findMatchingVariant() {
    return variants.find(function (v) {
      return (
        (v.option1 === selectedOptions[0] || selectedOptions[0] == null) &&
        (v.option2 === selectedOptions[1] || selectedOptions[1] == null || v.option2 == null) &&
        (v.option3 === selectedOptions[2] || selectedOptions[2] == null || v.option3 == null)
      );
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    // Update hidden input
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update GoKwik button
    var gkBtn = document.getElementById('gokwik-buy-now');
    if (gkBtn) gkBtn.dataset.variantid = variant.id;

    // Update price
    var priceEl = document.getElementById('mamash-price');
    var compareEl = document.getElementById('mamash-compare-price');
    var discountEl = document.getElementById('mamash-discount-badge');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        if (discountEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          discountEl.textContent = pct + '% off';
          discountEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }
    }

    // Update ATC availability
    var atcBtn = document.getElementById('mamash-atc-btn');
    var stickyAtc = document.getElementById('mamash-sticky-atc');
    var stickyBuy = document.getElementById('mamash-sticky-buy');
    var available = variant.available;
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
      // Re-add icon since textContent overwrites it
      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('width', '16'); icon.setAttribute('height', '16');
      icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor'); icon.setAttribute('stroke-width', '2');
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" x2="21" y1="6" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>';
      atcBtn.prepend(icon);
    }
    if (stickyAtc) stickyAtc.disabled = !available;
    if (stickyBuy) stickyBuy.disabled = !available;
    if (gkBtn) gkBtn.disabled = !available;
  }

  function formatMoney(cents) {
    // Format as ₹ Indian Rupees
    var rupees = (cents / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return rupees;
  }

  document.querySelectorAll('.mamash-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var position = parseInt(btn.dataset.optionPosition, 10);
      var value = btn.dataset.optionValue;

      selectedOptions[position] = value;

      // Update button active states within the same option group
      var group = btn.closest('[data-option-position="' + position + '"]');
      if (group) {
        group.querySelectorAll('.mamash-variant-btn').forEach(function (b) {
          var isSelected = b.dataset.optionValue === value;
          b.classList.toggle('border-primary', isSelected);
          b.classList.toggle('bg-primary/10', isSelected);
          b.classList.toggle('text-primary', isSelected);
          b.classList.toggle('border-border', !isSelected);
          b.classList.toggle('text-muted-foreground', !isSelected);
        });
      }

      // Update option label
      var labelEl = document.getElementById('mamash-option-label-' + position);
      if (labelEl) labelEl.textContent = value;

      // Find and apply matching variant
      var matched = findMatchingVariant();
      if (matched) updateVariantUI(matched);
    });
  });

  /* ══════════════════════════════════════════════════════════════════════
     QUANTITY STEPPER
  ══════════════════════════════════════════════════════════════════════ */
  var qtyInput = document.getElementById('mamash-qty-input');
  var qtyMinus = document.querySelector('.mamash-qty-minus');
  var qtyPlus = document.querySelector('.mamash-qty-plus');

  function getQty() { return parseInt(qtyInput ? qtyInput.value : '1', 10) || 1; }
  function setQty(v) { if (qtyInput) qtyInput.value = Math.max(1, Math.min(99, v)); }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(getQty() - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(getQty() + 1); });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () { setQty(getQty()); });
  }

  /* ══════════════════════════════════════════════════════════════════════
     STICKY MOBILE CTA
  ══════════════════════════════════════════════════════════════════════ */
  var stickyBar = document.getElementById('mamash-sticky-cta');
  var atcRow = document.getElementById('mamash-atc-row');

  if (stickyBar && atcRow && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.remove('translate-y-full');
          stickyBar.removeAttribute('aria-hidden');
        } else {
          stickyBar.classList.add('translate-y-full');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });
    observer.observe(atcRow);
  }

  /* ══════════════════════════════════════════════════════════════════════
     FAQ ACCORDION (inline, if pdp-rich-content uses .mamash-faq-item)
  ══════════════════════════════════════════════════════════════════════ */
  function initFaqAccordion() {
    document.querySelectorAll('.mamash-pdp-faq-item').forEach(function (item) {
      var btn = item.querySelector('button');
      var body = item.querySelector('.mamash-pdp-faq-body');
      var icon = item.querySelector('.mamash-pdp-faq-icon');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        // Close all in this FAQ block
        var container = item.closest('.mamash-pdp-faq');
        if (container) {
          container.querySelectorAll('.mamash-pdp-faq-item button').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var bd = b.closest('.mamash-pdp-faq-item').querySelector('.mamash-pdp-faq-body');
            var ic = b.closest('.mamash-pdp-faq-item').querySelector('.mamash-pdp-faq-icon');
            if (bd) bd.style.maxHeight = '0';
            if (ic) ic.style.transform = '';
          });
        }
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          if (icon) icon.style.transform = 'rotate(180deg)';
        }
      });
    });
  }
  initFaqAccordion();

  /* ══════════════════════════════════════════════════════════════════════
     SCROLL REVEAL (rich content sections)
  ══════════════════════════════════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mamash-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.mamash-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

})();
